// extracted by mini-css-extract-plugin
export var animationAbsolute = "_26-q";
export var animationRelative = "_26-p";
export var backdropBlur = "_26-0";
export var detailLabelCell = "_26-12";
export var detailTable = "_26-11";
export var detailValueCell = "_26-13";
export var docIconBox = "_26-1d";
export var docIconBoxMd = "_26-1f";
export var docIconBoxSm = "_26-1e";
export var docTypeRow = "_26-16";
export var docTypeRowInner = "_26-17";
export var dropdownMatchDatePicker = "_26-3";
export var evidenceCardContent = "_26-1c";
export var fileUploadSpin = "_26-j";
export var gorgiasOpenButton = "_26-15 _26-d";
export var gorgiasTicketCard = "_26-14";
export var heroModalFooterButton = "_26-18";
export var hiddenContainer = "_26-o";
export var iconPrimary = "_26-1g";
export var iconQuaternary = "_26-1i";
export var iconTertiary = "_26-1h";
export var integrationCard = "_26-1";
export var integrationLogoBox = "_26-2";
export var mainColumnSticky = "_26-1b";
export var maxWidthContainer = "_26-19";
export var modalContentBody = "_26-a";
export var modalHeaderImage = "_26-5";
export var modalImageLabel = "_26-7";
export var modalImageOverlay = "_26-6";
export var modalImageSubtitle = "_26-9";
export var modalImageTitle = "_26-8";
export var modalImageWrapper = "_26-4";
export var modalStickyFooter = "_26-b";
export var removeButton = "_26-e";
export var sidebarColumn = "_26-1a";
export var spinner = "_26-i";
export var timelineLine = "_26-y";
export var timelineLineBlack = "_26-10 _26-y";
export var timelineLineGray = "_26-z _26-y";
export var timelineLineHeight = "_26-x";
export var tlDotActivate = "_26-u";
export var tlDotActivateAnim = "_26-t";
export var tlDotHide = "_26-s";
export var tlDotHideAnim = "_26-r";
export var tlLineActivate = "_26-w";
export var tlLineActivateAnim = "_26-v";
export var uploadHint = "_26-n";
export var uploadIconBox = "_26-k";
export var uploadLabel = "_26-m";
export var uploadText = "_26-l";
export var uploadZone = "_26-f";
export var uploadZoneCursorDefault = "_26-h";
export var uploadZoneCursorPointer = "_26-g";
export var uploadedFileRow = "_26-c";
export var viewButton = "_26-d";